import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import {WINDOW, NAVIGATOR, DOCUMENT, HAS_TOUCH, IS_BROWSER, IS_MOBILE} from '../../constants/environment';
import './styles.css';
import BodyControl from "../../components/body";
import SweetScroll from "sweet-scroll";

/**
 *  AnchorNavigation
 */
class AnchorNavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string
  };
  static defaultProps = {
    containerId: null,
    containerClass: null
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      links: [],
      open: false,
      hasTouch: false,
      bottom: 0
    };
    this.intervalId = null;
  }

  componentDidMount() {
    if (this.props.invisible) return;
    setTimeout(this.init, 100);
  }

  init = (e) => {
    // ナビゲーションリスト生成
    const blocks = DOCUMENT.querySelectorAll('[data-anchor-name]');
    let links = [];
    for(let i = 0; i < blocks.length; i++){
      let block = blocks[i];
      let id = block.id && block.id !== '' ? block.id : (block.dataset.id && block.dataset.id !== '' ? block.dataset.id : null);
      let anchorName = block.dataset.anchorName;
      if(id && id !== '' && anchorName && anchorName !== ''){
        links.push(
          {
            id: id,
            anchorName: anchorName
          }
        );
      }
    }
    this.setState({
      links: links,
    });

    //タッチデバイスか否か（タブレット対応）
    if(HAS_TOUCH){
      this.setState({
        hasTouch: true
      });
    }

    // ナビゲーション上下中央
    // setTimeout(
    //   () => {
    //     const anchorNav = this.refs.anchorNavigation;
    //     const navHeight = anchorNav.getBoundingClientRect().height;
    //     anchorNav.style.marginTop = -Math.floor(navHeight / 2) + 'px';
    //     anchorNav.classList.add('show');
    //   },
    // 100);

    setTimeout(
      () => {
        const anchorNav = this.refs.anchorNavigation;
        anchorNav.style.height = anchorNav.querySelector('.AnchorNavigation__container').clientHeight + 'px';
        anchorNav.classList.add('show');
      },
    100);

    setTimeout(
      () => {
        if(!this.state.open){
          this.setState({
            open: true
          });
        }
      },
    200);

    // EPIServerのプレビュー時のモーダルの位置調整
    let isEpiServerPreview = false;
    if (WINDOW && WINDOW.epi && WINDOW.parent) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        isEpiServerPreview = true;
        setInterval(()=> {
          this.onScrollEpiPreview();
        }, 200);
        setTimeout(()=> {
          if(this.state.open){
            this.setState({
              open: false
            });
          }
        }, 3000)
      }
    }
    if (!isEpiServerPreview) {
      //スクロールイベント
      WINDOW.addEventListener('scroll', this.onScroll);
      this.triggerEvent(WINDOW, 'scroll');
    }

  };

  // サブナビゲーションの高さ取得
  getSubNavigationHeight = (e) => {
    const navigation = DOCUMENT.body.getElementsByClassName('StandardPage__navigation')[0] || null;
    if (!navigation) {
      return 0;
    } else {
      return navigation.clientHeight;
    }
  };

  onClick = (e) => {
    let targetNode = DOCUMENT.getElementById(e.currentTarget.dataset.id);
    //console.log(targetNode);
    // BodyControl.scrollToNode(targetNode);

    // ScrollLoaderコンポーネントの影響で正常に動かなくなったので自前でスクロール実装
    const navigationHeight = this.getSubNavigationHeight();
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      const windowTop = window.pageYOffset;
      const clientRect = targetNode.getBoundingClientRect();
      const targetTop = windowTop + clientRect.top - navigationHeight;
      const currentTop =  windowTop + ((targetTop - windowTop) * 0.15);
      if (Math.abs(targetTop - windowTop) <= 10) {
        if (this.intervalId) clearInterval(this.intervalId);
        // window.scrollTo(0, targetTop);
        // console.log('complete');
      } else {
        window.scrollTo(0, currentTop);
      }
    }, 1000 / 30);

    if(HAS_TOUCH){
      this.setState({
        open: false
      });
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  onMouseOver = (e) => {
    if(HAS_TOUCH){
      return false;
    }
    if(!this.state.open){
      this.setState({
        open: true
      });
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  onMouseOut = (e) => {
    if(HAS_TOUCH){
      return false;
    }
    if(this.state.open){
      this.setState({
        open: false
      });
    }
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  onClickHandle = (e) => {
    if(!HAS_TOUCH){
      return false;
    }
    this.setState({
      open: !this.state.open
    });
    return false;
  };

  onScroll = () => {

    let currentBlock;

    const blocks = DOCUMENT.querySelectorAll('[data-anchor-name]');

    const anchorNav = this.refs.anchorNavigation;

    for(let i = blocks.length - 1; i >= 0; i--){
      let offsetTop = blocks[i].getBoundingClientRect().top;
      let height = blocks[i].getBoundingClientRect().height;
      if(
        offsetTop < WINDOW.innerHeight * 0.2  && //対象ブロックが画面の半部より上にある
        // offsetTop <= 0  && //対象ブロックが画面の上端にある
        offsetTop + height > 0  // 画面内に一部でも残っている
      ){
        currentBlock = blocks[i];
        break;
      }
    }

    const anchorNavLinks = anchorNav.querySelectorAll('[data-id]');
    for(let i = 0; i < anchorNavLinks.length; i++){
      let anchorNavLink = anchorNavLinks[i];
      anchorNavLink.classList.remove('current');
      if(currentBlock != null && (anchorNavLink.dataset.id === currentBlock.dataset.id || anchorNavLink.dataset.id === currentBlock.id)){
        anchorNavLink.classList.add('current');
      }
    }

    if(this.state.open){
      this.setState({
        open: false
      });
    }

  };

  getRemain = () => {
    // 垂直スクロール量を取得する
    let scrollTop = DOCUMENT.body.scrollTop || DOCUMENT.documentElement.scrollTop;

    // 表示領域の高さを取得する
    let clientHeight = DOCUMENT.body.clientHeight;

    // スクロールバーで隠れた領域を含むコンテンツ領域の高さを取得する
    let scrollHeight = DOCUMENT.body.scrollHeight || DOCUMENT.docomentElement.scrollHeight;

    // Firefox・Chrome対応
    if(scrollHeight === clientHeight) {
      clientHeight = WINDOW.innerHeight;
    }

    // コンテンツ領域の底までの残り領域
    let remain = scrollHeight - clientHeight - scrollTop;

    return remain;
  };

  triggerEvent = (element, event) => {
    if (document.createEvent) {
      // IE以外
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent(event, true, true ); // event type, bubbling, cancelable
      return element.dispatchEvent(evt);
    } else {
      // IE
      var evt = document.createEventObject();
      return element.fireEvent("on"+event, evt)
    }
  };

  // EPIServerのプレビュー時のモーダルの位置調整
  onScrollEpiPreview = ()=> {
    const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
    if (wrapperElement) {
      const wrapperHeight = wrapperElement.clientHeight;
      const wrapperScrollTop = wrapperElement.scrollTop;
      //
      let currentBlock;
      const blocks = DOCUMENT.querySelectorAll('[data-anchor-name]');
      const anchorNav = this.refs.anchorNavigation;
      for(let i = blocks.length - 1; i >= 0; i--){
        let offsetTop = blocks[i].getBoundingClientRect().top - wrapperScrollTop;
        // let offsetTop = blocks[i].getBoundingClientRect().top;
        let height = blocks[i].getBoundingClientRect().height;
        if(
          offsetTop < wrapperHeight * 0.2  && //対象ブロックが画面の半部より上にある
          // offsetTop < WINDOW.innerHeight * 0.2  && //対象ブロックが画面の半部より上にある
          offsetTop + height > 0  // 画面内に一部でも残っている
        ){
          currentBlock = blocks[i];
          break;
        }
      }
      const anchorNavLinks = anchorNav.querySelectorAll('[data-id]');
      for(let i = 0; i < anchorNavLinks.length; i++){
        let anchorNavLink = anchorNavLinks[i];
        anchorNavLink.classList.remove('current');
        if(currentBlock != null && (anchorNavLink.dataset.id === currentBlock.dataset.id || anchorNavLink.dataset.id === currentBlock.id)){
          anchorNavLink.classList.add('current');
        }
      }
      // if(this.state.open){
      //   this.setState({
      //     open: false
      //   });
      // }
      //
      const bottom = (()=> {
        if (IS_MOBILE) {
          return DOCUMENT.body.clientHeight - (wrapperScrollTop + wrapperHeight);
        } else {
          return DOCUMENT.body.clientHeight - ((wrapperScrollTop + wrapperHeight) - 100);
        }
      })()
      this.setState({
        bottom: bottom,
      })
    }
  }

  render() {
    const {
      containerId,
      containerClass
    } = this.props;

    if (this.props.invisible) return null;

    //
    return (
      <Wrapper
        containerId={containerId}
        containerClass={containerClass}
      >
        <div
          className='AnchorNavigation'
          ref='anchorNavigation'
          style={(WINDOW && WINDOW.epi && WINDOW.parent) ? {position: 'fixed', bottom: this.state.bottom} : null}
        >
          <div className={'AnchorNavigation__container' + (this.state.open ? ' open' : '') + (this.state.hasTouch ? ' hasTouch' : '')} onMouseOver={this.onMouseOver}  onMouseOut={this.onMouseOut}>
            <ul className='AnchorNavigation__container__list'>
              {this.state.links.map((link, index) => {
                return(
                  <li className='AnchorNavigation__container__list__item' key={index}>
                    <a
                      href='javascript:void(0)'
                      data-id={link.id}
                      onClick={this.onClick}
                      className='AnchorNavigation__container__list__item__link'
                    >
                      <span className='AnchorNavigation__container__list__item__link__text'>
                        {link.anchorName}
                      </span>
                    </a>
                  </li>
                )
              })}
            </ul>
            <div className='AnchorNavigation__container__handle' onClick={this.onClickHandle}></div>
          </div>
        </div>
      </Wrapper>

    )
  }

}

export default AnchorNavigation;



// WEBPACK FOOTER //
// ./src/containers/anchor-navigation/index.jsx